<label>
  <div
    tabindex="0"
    (keydown.space)="$event.preventDefault(); toggle()"
    class="checkbox"
    [ngClass]="{ 'checkbox-active': _checked }"
  >
    <i class="icon fas fa-check"></i>
  </div>
  <ng-content></ng-content>
</label>
